import { Env } from "@stencil/core";
import Rollbar from "rollbar";

export const rollbar = new Rollbar({
  accessToken: Env.ROLLBAR_ACCESS_TOKEN,
  environment: Env.NODE_ENV,
  enabled: Env.NODE_ENV !== 'development',
  captureUncaught: false,
  captureUnhandledRejections: false,
  verbose: false,
  hostSafeList: ['customink.com'],
});
